import  {useContext, useEffect , useState} from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { faStar} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../style.css' ;
import Dealdata from "../components/Dealdata";
import Deal from "../components/Deal";
import { ReactComponent as Next } from '../assets/next.svg';
import { ReactComponent as Pre } from '../assets/pre.svg';
import UtmUpdate from "../components/WhatsAppUTMLinkUpdater";
import { CurrencyContext } from "../components/CurrencyContext";
// import ScrolltoTop from "../components/ScrolltoTop";
// import ItinerarySlider from "../components/ItinerarySlider";


const Destinations =()=> {

  const Currency = useContext(CurrencyContext);

     // Section - 1

   const [rsindex, rssetIndex] = useState(0); // initial slide index

   const [rscardsPerView, rssetCardsPerView] = useState(2);
 
   // Array of only the selected deals
   const rsselectedDeals = [Dealdata[86], Dealdata[87], Dealdata[88]];
 
   useEffect(() => {
       const rsupdateCardsPerView = () => {
         rssetCardsPerView(window.innerWidth < 768 ? 1 : 2);
       };
       rsupdateCardsPerView();
       window.addEventListener('resize', rsupdateCardsPerView);
       return () => window.removeEventListener('resize', rsupdateCardsPerView);
     }, []);
 
   const rsmaxIndex = rsselectedDeals.length - rscardsPerView;
 
   const rshandlePrev = () => {
     rssetIndex((prev) => (prev <= 0 ? rsmaxIndex : prev - 1));
   };
   
   const rshandleNext = () => {
     rssetIndex((prev) => (prev >= rsmaxIndex ? 0 : prev + 1));
   };
 
   const rsvisibleDeals = rsselectedDeals.slice(rsindex, rsindex + rscardsPerView);


// Section- 2


   const [index, setIndex] = useState(0); // initial slide index
   const [cardsPerView, setCardsPerView] = useState(2);
 
   // Array of only the selected deals
   const selectedDeals = [Dealdata[89], Dealdata[90], Dealdata[91], Dealdata[92], Dealdata[93]];
 
   useEffect(() => {
     const updateCardsPerView = () => {
       setCardsPerView(window.innerWidth < 768 ? 1 : 2);
     };
     updateCardsPerView();
     window.addEventListener('resize', updateCardsPerView);
     return () => window.removeEventListener('resize', updateCardsPerView);
   }, []);
 
 
   const maxIndex = selectedDeals.length - cardsPerView;
 
   const handlePrev = () => {
     setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
   };
   
   const handleNext = () => {
     setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
   };
 
   const visibleDeals = selectedDeals.slice(index, index + cardsPerView);
 
 
   // Section -3
 
   const [eindex, esetIndex] = useState(0); // initial slide index
 
   const [ecardsPerView, esetCardsPerView] = useState(2);
 
 
   // Array of only the selected deals
   const eselectedDeals = [Dealdata[94], Dealdata[95], Dealdata[96]];
 
   useEffect(() => {
     const eupdateCardsPerView = () => {
       esetCardsPerView(window.innerWidth < 768 ? 1 : 2);
     };
     eupdateCardsPerView();
     window.addEventListener('resize', eupdateCardsPerView);
     return () => window.removeEventListener('resize', eupdateCardsPerView);
   }, []);
 
   const emaxIndex = eselectedDeals.length - ecardsPerView;
 
   const ehandlePrev = () => {
     esetIndex((prev) => (prev <= 0 ? emaxIndex : prev - 1));
   };
   
   const ehandleNext = () => {
     esetIndex((prev) => (prev >= emaxIndex ? 0 : prev + 1));
   };
 
   const evisibleDeals = eselectedDeals.slice(eindex, eindex + ecardsPerView);





//  Section -4 

const [daaindex, daasetIndex] = useState(0); // initial slide index
 
const [daacardsPerView, daasetCardsPerView] = useState(2);


// Array of only the selected deals

const daaselectedDeals = [Dealdata[100], Dealdata[101], Dealdata[102]];

useEffect(() => {
  const daaupdateCardsPerView = () => {
    daasetCardsPerView(window.innerWidth < 768 ? 1 : 2);
  };
  daaupdateCardsPerView();
  window.addEventListener('resize', daaupdateCardsPerView);
  return () => window.removeEventListener('resize', daaupdateCardsPerView);
}, []);

const daamaxIndex = daaselectedDeals.length - daacardsPerView;

const daahandlePrev = () => {
  daasetIndex((prev) => (prev <= 0 ? daamaxIndex : prev - 1));
};

const daahandleNext = () => {
  daasetIndex((prev) => (prev >= daamaxIndex ? 0 : prev + 1));
};

const daavisibleDeals = daaselectedDeals.slice(daaindex, daaindex + daacardsPerView);


//  Section - 5

const [deeindex, deesetIndex] = useState(0); // initial slide index
 
const [deecardsPerView, deesetCardsPerView] = useState(2);


// Array of only the selected deals

const deeselectedDeals = [Dealdata[97], Dealdata[98], Dealdata[99]];

useEffect(() => {
  const deeupdateCardsPerView = () => {
    deesetCardsPerView(window.innerWidth < 768 ? 1 : 2);
  };
  deeupdateCardsPerView();
  window.addEventListener('resize', deeupdateCardsPerView);
  return () => window.removeEventListener('resize', deeupdateCardsPerView);
}, []);

const deemaxIndex = deeselectedDeals.length - deecardsPerView;

const deehandlePrev = () => {
  deesetIndex((prev) => (prev <= 0 ? deemaxIndex : prev - 1));
};

const deehandleNext = () => {
  deesetIndex((prev) => (prev >= deemaxIndex ? 0 : prev + 1));
};

const deevisibleDeals = deeselectedDeals.slice(deeindex, deeindex + deecardsPerView);


//  Section - 6
const [dclindex, dclsetIndex] = useState(0); // initial slide index
 
const [dclcardsPerView, dclsetCardsPerView] = useState(2);


// Array of only the selected deals

const dclselectedDeals = [Dealdata[103], Dealdata[104], Dealdata[105]];

useEffect(() => {
  const dclupdateCardsPerView = () => {
    dclsetCardsPerView(window.innerWidth < 768 ? 1 : 2);
  };
  dclupdateCardsPerView();
  window.addEventListener('resize', dclupdateCardsPerView);
  return () => window.removeEventListener('resize', dclupdateCardsPerView);
}, []);

const dclmaxIndex = dclselectedDeals.length - dclcardsPerView;

const dclhandlePrev = () => {
  dclsetIndex((prev) => (prev <= 0 ? dclmaxIndex : prev - 1));
};

const dclhandleNext = () => {
  dclsetIndex((prev) => (prev >= dclmaxIndex ? 0 : prev + 1));
};

const dclvisibleDeals = dclselectedDeals.slice(dclindex, dclindex + dclcardsPerView);




    return(
        <>

        <UtmUpdate/>
        
        <Navbar/>

         <div className="header">
                            <div className="offer-alert">
                                <div>
                                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                                    <FontAwesomeIcon icon={faStar} style={{color: "#f0ad4e",marginLeft:'5px'}} />
                                </div>
                                <p>4.8 Overall Rating and 5,00,000+ happy customers</p>
                            </div>
                            </div>


                            <div className="destination-header">
                                <h6>WE ARE TIRUN</h6>
                                <h2>EXPLORE MORE THAN 800 DESTINATIONS </h2>
                                <p>on all seven continents and across all the oceans</p>
                            </div>

                            <div className="destination-section-container">
                            <div className="royal-adventure destination-section-1"> 
                                        
                                        <div className="content">
                                        <h2>SOAK IT IN SUN - TROPICS</h2>
                                        <p>Escape to paradise with a tropical cruise to the Bahamas, Caribbean or Bermuda. Soak up the sun, enjoy water sports, indulge in
                                        local cuisine and experience island culture.</p>
                                        </div>
                                    {/* <div className="trip">
                                       <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a>
                                       <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[5].img } Dealname={Dealdata[5].Dealname}  /></a>
                                    </div> */}
                            
                                    <div className="carousel-wrapper" >
                                    <button onClick={rshandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
                                      <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
                                    </button>
                            
                                    <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
                                       {rsvisibleDeals.map((deal, i) => (
                                      <a
                                        key={i}
                                        href={deal.link[Currency.currencyCode]}
                                        target="_self"
                                        rel="noopener noreferrer"
                                        style={{ flex: '1', textDecoration: 'none' }}
                                      >
                                        <Deal img={deal.img} Dealname={deal.Dealname} />
                                      </a>
                                    ))}
                                    </div>
                                    <button
                                      onClick={rshandleNext} style={{backgroundColor:'transparent',border:'none'}} 
                                    >
                                     <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
                                    </button>
                                    
                                    </div>
                                    </div>



                                    <div className="royal-adventure destination-section-2"> 
            
            <div className="content ">
            <h2>ASTONISHING
            ASIA</h2>
            <p>Discover rich cultural heritage, ancient
wonders, and bustling cities as you sail
through Asia's majestic landscapes and vibrant coastlines</p>
            </div>

            <div className="carousel-wrapper" >
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}> */}
        <button onClick={handlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[8].img } Dealname={Dealdata[8].Dealname}  /></a>    */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[18].img } Dealname={Dealdata[18].Dealname}  /></a>    */}
           {visibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={handleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        
        </div>
        </div>



        <div className="royal-adventure destination-section-3 " > 
            
            <div className="content">
            <h2>OUTSTANDING OCEANIA</h2>
            <p>Explore the mesmerizing beauty of Oceania, where pristine beaches, lush rainforests, and unique wildlife await in the South Pacific's idyllic islands.</p>
            </div>

            <div className="carousel-wrapper" >
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}> */}
        <button onClick={ehandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[8].img } Dealname={Dealdata[8].Dealname}  /></a>    */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[18].img } Dealname={Dealdata[18].Dealname}  /></a>    */}
           {evisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={ehandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        {/* <div className="trip">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[9].img } Dealname={Dealdata[9].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[10].img } Dealname={Dealdata[10].Dealname}  /></a>   
        </div> */}
        </div>
        </div>

        {/* <div className="COCOCAY-container">
            <h2 className="Heading">Adventure for the Whole Pack</h2>
            <div className="cococay-heading" > 
            <h2>PERFECT DAY AT COCOCAY</h2>
            <button>View Itineraries</button>
            </div>
            </div> */}

         <div className="Celebrity-Offer-contaniner destination-section-4">

          <div className="content">
            <h2 className="Heading" style={{fontSize:'2.5rem'}}>ENCHANTING EUROPE</h2>
            <p className="Heading" style={{fontSize:'1rem',fontWeight:'500',lineHeight:'1.5'}}>Experience history, art, and romance as you cruise through Europe's enchanting coastlines, seas, and visit iconic cities that brim with timeless allure.</p>
          </div>
      
          <div className="carousel-wrapper" >
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}> */}
        <button onClick={deehandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[8].img } Dealname={Dealdata[8].Dealname}  /></a>    */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[18].img } Dealname={Dealdata[18].Dealname}  /></a>    */}
           {deevisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={deehandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        {/* <div className="trip">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[9].img } Dealname={Dealdata[9].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[10].img } Dealname={Dealdata[10].Dealname}  /></a>   
        </div> */}
        </div>
            </div>



            <div className="royal-adventure destination-section-5"  style={{marginTop:'20vh'}}> 
            
            <div className="content">
            <h2>AMAZING AMERICAS</h2>
            <p>Unearth the wonders of the Americas, from rugged Alaskan landscapes to tropical paradises, and immerse yourself in diverse cultures and scenic beauty.</p>
            </div>

            <div className="carousel-wrapper" >
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}> */}
        <button onClick={daahandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[4].img } Dealname={Dealdata[4].Dealname}   /></a> */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[8].img } Dealname={Dealdata[8].Dealname}  /></a>    */}
           {/* <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[18].img } Dealname={Dealdata[18].Dealname}  /></a>    */}
           {daavisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={daahandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
        {/* <div className="trip">
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer" >  <Deal img={Dealdata[9].img } Dealname={Dealdata[9].Dealname}   /></a>
           <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_blank" rel="noopener noreferrer"> <Deal img={Dealdata[10].img } Dealname={Dealdata[10].Dealname}  /></a>   
        </div> */}
        </div>
        </div>


        {/*  Climate Lovers section - 6 */}

        <div className="royal-adventure destination-section-6"  style={{marginTop:'20vh'}}> 
            
            <div className="content">
            <h2>FOR CLIMATE LOVERS AND THRILL SEEKERS</h2>
            <p>Embark on an unforgettable expedition, where you'll explore icy landscapes, witness breathtaking wildlife, and partake in thrilling shore excursions, all under the guidance of seasoned experts.</p>
            </div>

            <div className="carousel-wrapper" >
        <button onClick={dclhandlePrev} style={{backgroundColor:'transparent',border:'none'}} >
          <Pre style={{width:'30px', height:'30px',opacity:'0.3'}}/>
        </button>

        <div className="trip" style={{ display: 'flex', gap: '20px' , transition: 'transform 0.5s ease-in-out'}}>
           {dclvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.link[Currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Deal img={deal.img} Dealname={deal.Dealname} />
          </a>
        ))}
        </div>
        <button
          onClick={dclhandleNext} style={{backgroundColor:'transparent',border:'none'}} 
        >
         <Next style={{width:'30px', height:'30px', opacity:'0.3'}}/>
        </button>
       
        </div>
        </div>



        </div>
     
    {/* Slider using Swiper */}

       {/* <div className="itinerary-container">
       <h2 className="slider-heading">FOR CLIMATE LOVERS AND THRILL SEEKERS</h2>
        <p className="slider-subheading">ADVENTURES WITH TIRUN</p>

      <ItinerarySlider/>

      </div> */}

        {/* <ScrolltoTop/> */}

        <Footer/>
        </>
    );

}

export default Destinations ;